import Bugsnag from '@bugsnag/js';

import { getUserBrowserData } from '@automation-suite/shared-clients-user-browser-store';

import { BugsnagReporter } from '@automation-suite/shared-clients-bugsnag-reporter';
import { Logger, consoleReporter } from '@automation-suite/shared-clients-logger';

import { isThirdPartyScriptError } from './isThirdPartyScriptError';
import { withUserBrowserContext } from './transformations';

export const logger = new Logger({
  reporters: process.env['NX_PUBLIC_BUGSNAG_API_KEY']
    ? [
        new BugsnagReporter({
          client: Bugsnag.start({
            apiKey: process.env['NX_PUBLIC_BUGSNAG_API_KEY']!,
            appVersion: `web-${process.env['NX_PUBLIC_APP_NAME']}-${process.env['GIT_REVISION_HASH']}`,
            autoDetectErrors: process.env['NX_PUBLIC_APP_NAME'] !== 'widget-loader',
            onError: (event) => {
              if (
                isThirdPartyScriptError(event, {
                  appName: process.env['NX_PUBLIC_APP_NAME'],
                  buildHash: process.env['GIT_REVISION_HASH'],
                  currentPath: window.location?.pathname,
                })
              ) {
                return false;
              }

              event.addMetadata('session', {
                sessionId: getUserBrowserData().sessionId,
              });
              event.setUser(getUserBrowserData().browserId);

              return true;
            },
          }),
          reportableSeverities: ['error', 'warn'],
        }),
        consoleReporter,
      ]
    : [consoleReporter],
  transformations: [withUserBrowserContext],
});
